


import { getAccessLevel } from 'lib/access'

const allRoles= [
  'system_admin',
  'prog_manager',
  'pi',
  'project_officer',
  'mel_officer',
  'finance_liaison',
  'senior_management',
  'partner',
  'procurement',
]

const managementRoles= [
  'system_admin',
  'prog_manager',
  'pi',
  'senior_management',
]

const projectRoles= [
  'system_admin',
  'prog_manager',
  'pi',
  'project_officer',
  'mel_officer',
]

export const navigationConfig= [
  {
    label: 'Overview',
    items: [
      {
        title: 'Portfolio Dashboard',
        href: '/dashboard',
        icon: 'LayoutDashboard',
        roles: allRoles,
      },
    ],
  },
  {
    label: 'Grant Management',
    items: [
      {
        title: 'Proposals',
        href: '/dashboard/proposals',
        icon: 'FileText',
        roles: allRoles,
      },
      {
        title: 'Awards',
        href: '/dashboard/awards',
        icon: 'Award',
        roles: [...managementRoles, 'project_officer', 'finance_liaison'],
      },
      {
        title: 'Projects',
        href: '/dashboard/projects',
        icon: 'FolderKanban',
        roles: projectRoles,
      },
      {
        title: 'Workplans',
        href: '/dashboard/workplans',
        icon: 'GanttChart',
        roles: projectRoles,
      },
    ],
  },
  {
    label: 'MEL & Impact',
    items: [
      {
        title: 'Logframes',
        href: '/dashboard/mel',
        icon: 'Network',
        roles: ['system_admin', 'prog_manager', 'pi', 'mel_officer'],
      },
      {
        title: 'Indicators',
        href: '/dashboard/mel/indicators',
        icon: 'TrendingUp',
        roles: ['system_admin', 'prog_manager', 'pi', 'mel_officer', 'project_officer'],
      },
      {
        title: 'Evidence',
        href: '/dashboard/evidence',
        icon: 'FileCheck',
        roles: projectRoles,
      },
    ],
  },
  {
    label: 'Reporting',
    items: [
      {
        title: 'Reports',
        href: '/dashboard/reports',
        icon: 'FileText',
        roles: [...managementRoles, 'mel_officer', 'project_officer'],
      },
      {
        title: 'Compliance',
        href: '/dashboard/reports/compliance',
        icon: 'ShieldCheck',
        roles: managementRoles,
      },
    ],
  },
  {
    label: 'Risk & Issues',
    items: [
      {
        title: 'Risks',
        href: '/dashboard/risks',
        icon: 'AlertTriangle',
        roles: projectRoles,
      },
      {
        title: 'Issues',
        href: '/dashboard/issues',
        icon: 'AlertCircle',
        roles: projectRoles,
      },
    ],
  },
  {
    label: 'Stakeholders',
    items: [
      {
        title: 'Stakeholders',
        href: '/dashboard/stakeholders',
        icon: 'Users',
        roles: projectRoles,
      },
      {
        title: 'Partners',
        href: '/dashboard/partners',
        icon: 'Handshake',
        roles: [...managementRoles, 'partner'],
      },
    ],
  },
  {
    label: 'Finance',
    items: [
      {
        title: 'Financial Monitor',
        href: '/dashboard/finance',
        icon: 'DollarSign',
        roles: ['system_admin', 'prog_manager', 'finance_liaison', 'senior_management'],
      },
    ],
  },
  {
    label: 'Dashboards',
    items: [
      {
        title: 'Delivery',
        href: '/dashboard/dashboards/delivery',
        icon: 'CheckCircle',
        roles: allRoles,
      },
      {
        title: 'MEL Dashboard',
        href: '/dashboard/dashboards/mel',
        icon: 'BarChart3',
        roles: allRoles,
      },
      {
        title: 'Risk & Issues',
        href: '/dashboard/dashboards/risks',
        icon: 'ShieldAlert',
        roles: allRoles,
      },
      {
        title: 'Outputs',
        href: '/dashboard/dashboards/outputs',
        icon: 'PackageCheck',
        roles: allRoles,
      },
    ],
  },
  {
    label: 'Administration',
    items: [
      {
        title: 'User Management',
        href: '/dashboard/admin/users',
        icon: 'UserCog',
        roles: ['system_admin'],
      },
      {
        title: 'Audit Logs',
        href: '/dashboard/admin/audit',
        icon: 'ScrollText',
        roles: ['system_admin'],
      },
      {
        title: 'Settings',
        href: '/dashboard/settings',
        icon: 'Settings',
        roles: ['system_admin'],
      },
    ],
  },
]

const limitedTitles = new Set([
  'Portfolio Dashboard',
  'Proposals',
  'Awards',
  'Projects',
  'Workplans',
])

export function getNavigationForRole(userType) {
  const level = getAccessLevel(userType)
  if (level !== 'limited') {
    return navigationConfig
  }

  return navigationConfig
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => limitedTitles.has(item.title)),
    }))
    .filter((section) => section.items.length > 0)
}
